const SendFeedbackIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 21 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.8159 6.7417C12.6409 6.7417 12.4836 6.84636 12.417 7.00812C12.3504 7.16915 12.3869 7.35506 12.5106 7.47875C12.6343 7.60244 12.8202 7.63904 12.9813 7.57243C13.143 7.50583 13.2477 7.34847 13.2477 7.17354C13.2477 6.93494 13.0545 6.7417 12.8159 6.7417Z"
        className="fill-color stroke-color"
        strokeWidth={0.5}
      />
      <path
        d="M7.17331 7.60038C7.34824 7.60038 7.50633 7.49425 7.57294 7.33249C7.63955 7.17001 7.60148 6.98409 7.47706 6.86114C7.3519 6.73818 7.16525 6.70231 7.00424 6.77038C6.84322 6.83918 6.73928 6.998 6.74149 7.17366C6.74149 7.28784 6.78687 7.3969 6.86811 7.47741C6.94935 7.55719 7.05913 7.60184 7.17331 7.60038Z"
        className="fill-color stroke-color"
        strokeWidth={0.5}
      />
      <path
        d="M17.8693 2.12469C17.5758 1.83046 17.1769 1.66578 16.7605 1.66651H3.2286C2.36566 1.66651 1.66669 2.3655 1.66669 3.22842V14.746C1.66669 15.609 2.36568 16.3079 3.2286 16.3079H7.56965L9.30796 18.0411H9.30723C9.49167 18.2278 9.74272 18.3332 10.0048 18.3332C10.2675 18.3332 10.5186 18.2278 10.7023 18.0411L12.4406 16.3079H16.7605C17.6234 16.3079 18.3224 15.6089 18.3224 14.746V3.22842C18.3231 2.81489 18.1606 2.41819 17.8693 2.12469ZM17.4741 14.7459C17.477 14.9355 17.4024 15.117 17.2677 15.2502C17.133 15.3827 16.95 15.4544 16.7605 15.4486H12.2532C12.1405 15.45 12.0322 15.4947 11.9517 15.5737L10.0933 17.4321C10.0377 17.4833 9.9513 17.4833 9.89567 17.4321L8.03731 15.5737C7.9568 15.4947 7.84848 15.45 7.73575 15.4486H3.22851C3.04114 15.4515 2.86036 15.3783 2.72787 15.2465C2.59613 15.1141 2.52292 14.9333 2.52586 14.7459V3.22831C2.52294 3.03948 2.5954 2.85868 2.72787 2.72475C2.85962 2.59007 3.03968 2.51469 3.22851 2.51469H16.7604C16.9507 2.51176 17.1336 2.58641 17.2683 2.72036C17.4022 2.85504 17.4769 3.03802 17.474 3.22831L17.4741 14.7459Z"
        className="fill-color stroke-color"
        strokeWidth={0.5}
      />
      <path
        d="M12.8891 9.76531C12.6578 9.72798 12.4397 9.88315 12.3994 10.1144C12.3994 10.1715 12.0979 11.6449 9.99508 11.6449C7.89227 11.6449 7.60102 10.1825 7.59071 10.1144C7.55046 9.88314 7.33234 9.72798 7.10105 9.76531C6.99053 9.7836 6.89172 9.84435 6.82659 9.93511C6.76146 10.0259 6.73437 10.1393 6.75266 10.2491C6.87197 11.0352 7.72027 12.4873 9.99514 12.4873C12.27 12.4873 13.1183 11.0249 13.2376 10.2491C13.272 10.02 13.1175 9.80555 12.8891 9.76531Z"
        className="fill-color stroke-color"
        strokeWidth={0.5}
      />
    </svg>
  );
};
export default SendFeedbackIcon;
